<app-header [isHome]=true></app-header>

<section id="hero-search" class="hero-search">

	<div class="hero-search-img"></div>


    <div class="container -mt75">

        <div class="row">
           <div class="col-lg-12 content-hero-search">
           		<h1 class="text-center"> El espacio que estás buscando está aquí.</h1>
            </div>

        </div>

         <div class="row">
            
           <div class="col-lg-12 content-hero-search mt-4">

            <!-- <ul class="nav nav-pills magic-line-menu">
              
              <li><a  (click)="change2Rent()" class="active">Alquilar</a></li>
              <li><a (click)="change2Buy()">Comprar</a></li>
              
            </ul> -->
            
            <div id="alquilar">        
              <form [formGroup]="myForm" (ngSubmit)="searchEnd()">
                  <div class="col-lg-12 search-inner">

                    <mat-form-field class="mimat" appearance="fill" (click)="clearUse()">
                      <mat-label>Selecciona</mat-label>
                      <mat-select formControlName="isSearchFor">
                        <mat-option value="Alquilar">Alquilar</mat-option>
                        <mat-option value="Comprar">Comprar</mat-option>
                      </mat-select>
                    </mat-form-field>
                    

                     <mat-form-field class="mitipo" appearance="fill" (click)="clearUse()">
                      <mat-label>Tipo de inmueble</mat-label>
                      <mat-select formControlName="use">
                        <mat-option *ngFor="let item of uses" [value]="item.id">
                          {{item.name}}
                          </mat-option>
                      </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="example-full-width" appearance="fill" (click)="clearProvince()">
                      <mat-label>Provincia</mat-label>
                      <input type="text"
                      placeholder="Provincia"
                      matInput
                      formControlName="province"
                      [matAutocomplete]="auto">
                      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFnProvince.bind(this)">
                        <mat-option *ngFor="let option of filteredProvinces | async" [value]="option.id">
                          {{option.name}}
                        </mat-option>
                      </mat-autocomplete>
                      <mat-icon matSuffix class="mat-icon-select">arrow_drop_down</mat-icon>
                    </mat-form-field>

                    <mat-form-field class="example-full-width" appearance="fill" (click)="clearCity()">
                      <mat-label>Municipio</mat-label>
                      <input type="text"
                             placeholder="Municipio"
                             matInput
                             formControlName="city"
                             [matAutocomplete]="autoCity">
                      <mat-autocomplete #autoCity="matAutocomplete" [displayWith]="displayFnCity.bind(this)">
                        <mat-option *ngFor="let option of filteredCities | async" [value]="option.id">
                          {{option.name}}
                        </mat-option>
                      </mat-autocomplete>
                      <mat-icon matSuffix class="mat-icon-select">arrow_drop_down</mat-icon>
                    </mat-form-field>

                    <mat-form-field class="mitipo" appearance="fill">
                      <mat-label>Distrito</mat-label>
                      <mat-select formControlName="district">
                        <mat-option *ngFor="let item of districts" [value]="item.id">
                          {{item.name}}
                          </mat-option>
                      </mat-select>
                    </mat-form-field>




                     <button class="btn btn-search bradius-r" type="submit"
                     [ngClass]="{'btn-search-disabled': !myForm.valid || found ===0}"
                     [disabled]="myForm.valid && (found > 0)? false: true"


                     >Buscar&nbsp;({{found}})</button>
                     <!-- <button class="btn btn-search bradius-r" type="submit"
                     >Buscar&nbsp;({{found}})</button> -->

                  </div>
            
                </form>
               </div> 

                
            </div>
            

        </div>

     

    </div>

 
   


</section><!-- fin hero-->


<!-- Chat Assistant Component -->
<app-chat-assistant></app-chat-assistant>

<app-footer-main></app-footer-main>
